import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		TOUCH_TIP_SHOW: true,	// 看板娘touch提示显示状态
	},
	mutations: {
		SET_TOUCH_TIP_SHOW: (state, params) => {
			state.TOUCH_TIP_SHOW = params;
		}
	},
	actions: {
	}
})
